import React from "react";
import { Tooltip } from "flowbite-react";
import { useTranslation } from "react-i18next";
import { isSymbolLibraryTabDisabledIn3D } from "./symbolLibrary3DAvailability";

export interface SymbolLibraryTabBarProps {
  tabs: string[];
  activeTab: string;
  onTabChange: (tab: string) => void;
  formatTabLabel: (tab: string) => string;
  className?: string;
  is3DView?: boolean;
}

export const SymbolLibraryTabBar: React.FC<SymbolLibraryTabBarProps> = ({
  tabs,
  activeTab,
  onTabChange,
  formatTabLabel,
  className,
  is3DView = false,
}) => {
  const { t } = useTranslation();

  if (tabs.length <= 1) {
    return null;
  }

  return (
    <div className={`flex gap-4 ${className ?? ""}`}>
      {tabs.map((tab) => {
        const isActive = tab === activeTab;
        const disabled = is3DView && isSymbolLibraryTabDisabledIn3D(tab);
        const disabledTooltip =
          tab === "ELEVATION"
            ? t("symbols.elevationHiddenIn3D")
            : t("symbols.unavailableIn3D");
        const button = (
          <button
            type="button"
            onClick={() => {
              if (!disabled) {
                onTabChange(tab);
              }
            }}
            className={`px-3 py-1 text-sm font-normal transition-colors ${
              disabled
                ? "pointer-events-none cursor-not-allowed text-gray-400 opacity-40"
                : isActive
                  ? "rounded border border-[#edebe6] text-black"
                  : "text-black"
            }`}
            disabled={disabled}
            aria-disabled={disabled || undefined}
          >
            {formatTabLabel(tab)}
          </button>
        );

        if (!disabled) {
          return <React.Fragment key={tab}>{button}</React.Fragment>;
        }

        // Wrapper keeps hover events (disabled buttons don't), Flowbite dark tooltip matches toolbar.
        return (
          <Tooltip
            key={tab}
            content={disabledTooltip}
            placement="bottom"
            style="dark"
          >
            <span className="inline-flex">{button}</span>
          </Tooltip>
        );
      })}
    </div>
  );
};
